import { data } from '../../svg/RegularExpression/data';
import { makeIcon } from '../makeIcon';

export const RegularExpression = makeIcon(data, 'regular_expression', 'RegularExpression');

export default RegularExpression;
